import { useState, useCallback, useRef, useEffect } from "react";

type TRetryStatus = {
  message: string;
  retryCount: number;
  doesPersist: null | boolean;
};

const initialRetryStatus = {
  message: "",
  retryCount: 0,
  doesPersist: null,
};

export function useRetry(maxRetries = 3, baseDelay = 1200) {
  const [retryStatus, setRetryStatus] =
    useState<TRetryStatus>(initialRetryStatus);

  // timeout ID'yi saklamak için ref
  const timeoutRef = useRef<number | null>(null);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function retry(count: number, error: { stack: any; message: string }) {
    // önceki timeout varsa temizle (isteğe bağlı, birden çok retry çağrısında üst üste binmesin diye)
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (count < maxRetries) {
      const delay = baseDelay * count ** 2;

      // timeout ID'yi ref'e ata
      timeoutRef.current = window.setTimeout(() => {
        setRetryStatus((prev) => ({
          ...prev,
          message: error.message,
          retryCount: count + 1,
        }));
      }, delay);
    } else {
      setRetryStatus((prev) => ({
        ...prev,
        doesPersist: true,
      }));
    }
  }

  const reset = useCallback(() => {
    // timeout varsa iptal et
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    // durumu ilk haline döndür
    setRetryStatus(initialRetryStatus);
  }, []);

  // Component unmount olduğunda da timeout'u temizlemek iyi pratiktir
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return {
    retryStatus,
    retry,
    reset,
  };
}
